export default __webpack_public_path__ + "static/media/ic-pending.a668e06f.svg";